import { useTailwind } from "tailwind-rn";
import { parseDateISO } from "utils";

import { PickupTrackingInstructions } from "../../../types";
import CardText from "../../CardText";

type Props = {
  data: PickupTrackingInstructions;
};

export default function PickupTracking({ data }: Props) {
  const tailwind = useTailwind();
  if (!data.text) return null;

  const eta = data.eta ? parseDateISO(data.eta) : "a la hora preestablecida";
  const text = `${data.text} ${eta}`;

  return <CardText.Label text={text} style={tailwind("mt-2 mb-3")} />;
}
